/* eslint-disable */
// @ts-nocheck
import { patch } from 'rrweb/es/rrweb/packages/rrweb/src/utils';

// TODO: use the built-in plugin once merged

export function findLast(
  array,
  // @ts-expect-error
  predicate
) {
  const length = array.length
  for (let i = length - 1; i >= 0; i -= 1) {
    // @ts-expect-error
    if (predicate(array[i])) {
      return array[i]
    }
  }
}

const defaultNetworkOptions = {
  initiatorTypes: [
    "audio",
    "beacon",
    "body",
    "css",
    "early-hint",
    "embed",
    "fetch",
    "frame",
    "iframe",
    "icon",
    "image",
    "img",
    "input",
    "link",
    "navigation",
    "object",
    "ping",
    "script",
    "track",
    "video",
    "xmlhttprequest"
  ],
  ignoreRequestFn: () => false,
  recordHeaders: false,
  recordBody: false,
  recordInitialRequests: false
}

const isNavigationTiming = entry => entry.entryType === "navigation"
const isResourceTiming = entry => entry.entryType === "resource"

function initPerformanceObserver(cb, win, options) {
  if (options.recordInitialRequests) {
    const initialPerformanceEntries = win.performance
      .getEntries()
      .filter(
        entry =>
          isNavigationTiming(entry) ||
          (isResourceTiming(entry) &&
            options.initiatorTypes.includes(entry.initiatorType))
      )
    cb({
      requests: initialPerformanceEntries.map(entry => ({
        url: entry.name,
        initiatorType: entry.initiatorType,
        status: "responseStatus" in entry ? entry.responseStatus : undefined,
        startTime: Math.round(entry.startTime),
        endTime: Math.round(entry.responseEnd)
      })),
      isInitial: true
    })
  }
  const observer = new win.PerformanceObserver(entries => {
    const performanceEntries = entries
      .getEntries()
      .filter(
        entry =>
          isNavigationTiming(entry) ||
          (isResourceTiming(entry) &&
            options.initiatorTypes.includes(entry.initiatorType) &&
            entry.initiatorType !== "xmlhttprequest" &&
            entry.initiatorType !== "fetch")
      )
    cb({
      requests: performanceEntries.map(entry => ({
        url: entry.name,
        initiatorType: entry.initiatorType,
        status: "responseStatus" in entry ? entry.responseStatus : undefined,
        startTime: Math.round(entry.startTime),
        endTime: Math.round(entry.responseEnd)
      }))
    })
  })
  observer.observe({ entryTypes: ["navigation", "resource"] })
  return () => {
    observer.disconnect()
  }
}

function shouldRecordHeaders(type, recordHeaders) {
  return (
    !!recordHeaders &&
    (typeof recordHeaders === "boolean" || recordHeaders[type])
  )
}

function shouldRecordBody(type, recordBody, headers) {
  function matchesContentType(contentTypes) {
    const contentTypeHeader = Object.keys(headers).find(
      key => key.toLowerCase() === "content-type"
    )
    const contentType = contentTypeHeader && headers[contentTypeHeader]
    return contentTypes.some(ct => contentType?.includes(ct))
  }
  if (!recordBody) return false
  if (typeof recordBody === "boolean") return true
  if (Array.isArray(recordBody)) return matchesContentType(recordBody)
  const recordBodyType = recordBody[type]
  if (typeof recordBodyType === "boolean") return recordBodyType
  return matchesContentType(recordBodyType)
}

async function getRequestPerformanceEntry(
  win,
  initiatorType,
  url,
  after,
  before,
  attempt = 0
) {
  if (attempt > 10) {
    throw new Error("Cannot find performance entry")
  }
  const urlPerformanceEntries = win.performance.getEntriesByName(url)
  const performanceEntry = findLast(
    urlPerformanceEntries,
    entry =>
      isResourceTiming(entry) &&
      entry.initiatorType === initiatorType &&
      (!after || entry.startTime >= after) &&
      (!before || entry.startTime <= before)
  )
  if (!performanceEntry) {
    await new Promise(resolve => setTimeout(resolve, 50 * attempt))
    return getRequestPerformanceEntry(
      win,
      initiatorType,
      url,
      after,
      before,
      attempt + 1
    )
  }
  return performanceEntry
}

function initXhrObserver(cb, win, options) {
  if (!options.initiatorTypes.includes("xmlhttprequest")) {
    return () => {
      //
    }
  }
  const recordRequestHeaders = shouldRecordHeaders(
    "request",
    options.recordHeaders
  )
  const recordResponseHeaders = shouldRecordHeaders(
    "response",
    options.recordHeaders
  )
  const restorePatch = patch(
    win.XMLHttpRequest.prototype,
    "open",
    originalOpen => {
      return function(method, url, async = true, username, password) {
        // @ts-expect-error
        const xhr = this
        const req = new Request(url)
        const networkRequest = {}
        let after
        let before
        const requestHeaders = {}
        const originalSetRequestHeader = xhr.setRequestHeader.bind(xhr)
        xhr.setRequestHeader = (header, value) => {
          requestHeaders[header] = value
          return originalSetRequestHeader(header, value)
        }
        if (recordRequestHeaders) {
          networkRequest.requestHeaders = requestHeaders
        }
        const originalSend = xhr.send.bind(xhr)
        xhr.send = body => {
          if (shouldRecordBody("request", options.recordBody, requestHeaders)) {
            networkRequest.requestBody =
              body === undefined || body === null ? null : body
          }
          after = win.performance.now()
          return originalSend(body)
        }
        xhr.addEventListener("readystatechange", () => {
          if (xhr.readyState !== xhr.DONE) {
            return
          }
          before = win.performance.now()
          const responseHeaders = {}
          const rawHeaders = xhr.getAllResponseHeaders()
          const headers = rawHeaders.trim().split(/[\r\n]+/)
          for (const line of headers) {
            const parts = line.split(": ")
            const header = parts.shift()
            const value = parts.join(": ")
            if (header) {
              responseHeaders[header] = value
            }
          }
          if (recordResponseHeaders) {
            networkRequest.responseHeaders = responseHeaders
          }
          if (
            shouldRecordBody("response", options.recordBody, responseHeaders)
          ) {
            // eslint-disable-next-line unicorn/prefer-ternary
            if (xhr.response === undefined || xhr.response === null) {
              networkRequest.responseBody = null
            } else {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              networkRequest.responseBody = xhr.response
            }
          }
          getRequestPerformanceEntry(
            win,
            "xmlhttprequest",
            req.url,
            after,
            before
          )
            .then(entry => {
              const request = {
                url: entry.name,
                method: req.method,
                initiatorType: entry.initiatorType,
                status: xhr.status,
                startTime: Math.round(entry.startTime),
                endTime: Math.round(entry.responseEnd),
                requestHeaders: networkRequest.requestHeaders,
                requestBody: networkRequest.requestBody,
                responseHeaders: networkRequest.responseHeaders,
                responseBody: networkRequest.responseBody
              }
              cb({ requests: [request] })
            })
            .catch(() => {
              //
            })
        })
        originalOpen.call(xhr, method, url, async, username, password)
      }
    }
  )
  return () => {
    restorePatch()
  }
}

function initFetchObserver(cb, win, options) {
  if (!options.initiatorTypes.includes("fetch")) {
    return () => {
      //
    }
  }
  const recordRequestHeaders = shouldRecordHeaders(
    "request",
    options.recordHeaders
  )
  const recordResponseHeaders = shouldRecordHeaders(
    "response",
    options.recordHeaders
  )
  const restorePatch = patch(win, "fetch", originalFetch => {
    return async function(url, init) {
      const req = new Request(url, init)
      let res
      const networkRequest = {}
      let after
      let before
      try {
        const requestHeaders = {}
        for (const [header, value] of req.headers.entries()) {
          requestHeaders[header] = value
        }
        if (recordRequestHeaders) {
          networkRequest.requestHeaders = requestHeaders
        }
        if (shouldRecordBody("request", options.recordBody, requestHeaders)) {
          networkRequest.requestBody =
            req.body === undefined || req.body === null ? null : req.body
        }
        after = win.performance.now()
        res = await originalFetch(req)
        before = win.performance.now()
        const responseHeaders = {}
        for (const [header, value] of res.headers.entries()) {
          responseHeaders[header] = value
        }
        if (recordResponseHeaders) {
          networkRequest.responseHeaders = responseHeaders
        }
        if (shouldRecordBody("response", options.recordBody, responseHeaders)) {
          let body
          try {
            body = await res.clone().text()
          } catch {
            console.error("no body")
          }
          networkRequest.responseBody =
            res.body === undefined || res.body === null ? null : body
        }

        const request = {
          url: url.toString(),
          method: req.method,
          // initiatorType: entry.initiatorType as InitiatorType,
          status: res?.status,
          // startTime: Math.round(entry.startTime),
          // endTime: Math.round(entry.responseEnd),
          requestHeaders: networkRequest.requestHeaders,
          requestBody: networkRequest.requestBody,
          responseHeaders: networkRequest.responseHeaders,
          responseBody: networkRequest.responseBody
        }
        cb({ requests: [request] })

        return res
      } catch (e) {
        console.error("fetch error", e)
      } finally {
        // console.log('finally')
        // getRequestPerformanceEntry(win, 'fetch', req.url, after, before)
        //   .then((entry) => {
        //     const request: NetworkRequest = {
        //       url: entry.name,
        //       method: req.method,
        //       initiatorType: entry.initiatorType as InitiatorType,
        //       status: res?.status,
        //       startTime: Math.round(entry.startTime),
        //       endTime: Math.round(entry.responseEnd),
        //       requestHeaders: networkRequest.requestHeaders,
        //       requestBody: networkRequest.requestBody,
        //       responseHeaders: networkRequest.responseHeaders,
        //       responseBody: networkRequest.responseBody,
        //     }
        //     console.log('request', request)
        //     cb({ requests: [request] })
        //   })
        //   .catch((e) => {
        //     console.error('fetch error', e)
        //   })
      }
    }
  })
  return () => {
    restorePatch()
  }
}

function initNetworkObserver(
  callback,
  // top window or in an iframe
  win,
  options
) {
  if (!("performance" in win)) {
    return () => {
      //
    }
  }
  const networkOptions = options
    ? Object.assign({}, defaultNetworkOptions, options)
    : defaultNetworkOptions

  const cb = data => {
    const requests = data.requests.filter(
      request => !networkOptions.ignoreRequestFn(request)
    )
    if (requests.length > 0 || data.isInitial) {
      callback({ ...data, requests })
    }
  }
  const performanceObserver = initPerformanceObserver(cb, win, networkOptions)
  const xhrObserver = initXhrObserver(cb, win, networkOptions)
  const fetchObserver = initFetchObserver(cb, win, networkOptions)
  return () => {
    performanceObserver()
    xhrObserver()
    fetchObserver()
  }
}

export const NETWORK_PLUGIN_NAME = "rrweb/network@1"

export const getRecordNetworkPlugin = options => ({
  name: NETWORK_PLUGIN_NAME,
  // @ts-expect-error
  observer: initNetworkObserver,
  options: options
})

export const getReplayNetworkPlugin = options => {
  return {
    handler(event) {
      if (
        event.type === EventType.Plugin &&
        event.data.plugin === NETWORK_PLUGIN_NAME
      ) {
        const networkData = event.data.payload
        options.onNetworkData(networkData)
      }
    }
  }
}
